<template>
  <div>
    <p class="message" v-html="getVerificationError(verification)"></p>
    <button class="primary-button" @click="onTryAgainClick">
      {{ $t('discount.voucher.verificationError.button') }}
    </button>
  </div>
</template>
<style scoped>
@import '../../../assets/css/button-style.css';

.message {
  margin: 0, 0, 10px;
}
</style>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'verification-error',
  computed: {
    ...mapState({
      verification: (state) => state.voucher.verification,
    }),
  },
  methods: {
    ...mapActions({
      setVoucherWizardStep: 'setVoucherWizardStep',
    }),
    onTryAgainClick() {
      this.setVoucherWizardStep('verification');
    },
    getVerificationError(verification) {
      if (!verification || !verification.benefitEligibilityViolations) {
        return this.$t('discount.voucher.verificationError.info');
      }
      const eligibilityViolations = verification.benefitEligibilityViolations;

      // Check if there are age restriction violations
      if (eligibilityViolations && eligibilityViolations.some((result) => result === 'MAX_AGE_INVALID' || result === 'MIN_AGE_INVALID')) {
        return this.$t('discount.voucher.verificationError.notEligible');
      }

      // Default verification error message
      return this.$t('discount.voucher.verificationError.info');
    },
  },
};
</script>
